import React from 'react';
import './customers.css';
import {Col, Container, Image, Row} from "react-bootstrap";
import {Swiper, SwiperSlide} from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// import required modules
import {Navigation} from 'swiper/modules';


function Customers({comments}) {
    return (

        <Container className={'customers-container'}>
            <Row className={'customers-row'}>
                <Col className={'customers-col'}>
                    <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
                        {comments.map((comment)=>(
                            <SwiperSlide key={comment.id}>
                                <Image src={comment.image}></Image>
                                <h5>{comment.name}</h5>
                                <p>{comment.message}</p>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Col>
            </Row>
        </Container>
    );
}

export default Customers;